import { render, staticRenderFns } from "./LetterCreate.vue?vue&type=template&id=3796e280&"
import script from "./LetterCreate.vue?vue&type=script&lang=js&"
export * from "./LetterCreate.vue?vue&type=script&lang=js&"
import style0 from "./LetterCreate.vue?vue&type=style&index=0&id=3796e280&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports